import axios from "../axiosConfig";
import {userConstants} from "../../constants";
import {trackPromise} from "react-promise-tracker";

export const actionGetOwnActivityLog = () => async dispatch => {
    const response = await trackPromise(axios.get(`audit/own`));
    dispatch({
        type: userConstants.ACTION_GET_ACTIVITY_LOG,
        payload: response.data.data
    });
};
